import { Component } from 'react';
import SubsidyContractCoverLetter from './SubsidyContractCoverLetter';

class SubsidyContractCover extends Component {
    render() {
        return (
            <SubsidyContractCoverLetter />
        )
    }
}
export default SubsidyContractCover;
